import React from 'react';
import cn from 'classnames';

import { IconSize } from 'widget/shared/icons/BaseIcon';
import { IWidgetChannel } from 'widget/entities/channel';
import { ChannelsConfig } from 'widget/consts/channel';

import styles from './WidgetChannel.module.scss';

export type WidgetChannelProps = {
  channel: IWidgetChannel;
  className?: string;
  withShadow?: boolean;
};

const WidgetChannel: React.FC<WidgetChannelProps> = ({
  channel,
  className,
  withShadow = false
}) => {
  const Icon = ChannelsConfig[channel.kind];

  const channelClassName = cn(
    styles['channel'],
    withShadow && styles['channel_with-shadow'],
    className
  );

  if (!channel.url) {
    return (
      <span className={cn(channelClassName, styles['channel_placeholder'])}>
        <Icon size={IconSize.XXL} />
      </span>
    );
  }

  return (
    <a
      href={channel.url}
      target="_blank"
      rel="noopener noreferrer"
      className={channelClassName}
    >
      <Icon size={IconSize.XXL} />
    </a>
  );
};

export default React.memo(WidgetChannel);
